import { filter, pipe, split } from 'ramda';

export const isZipCode = (string) => /(^\d{5}$)/.test(string);

export const parseZips = pipe(split(/[, -]/), filter(isZipCode));
